import * as dbDocuments from 'serviceWorker/db/documents';
import type { DocumentEntity } from 'serviceWorker/repository/document/entity';
import type { AttachmentCountsOfIssues } from 'shared/domain/document/documentContract';
import {
  toAttachmentCounts,
  toPdfClassifiableDocument,
} from 'shared/domain/report/estimate/classifyDocumentsForPdfEstimate';
import { isDefinedValue } from 'shared/utils/value';

function groupByIssueId(documents: DocumentEntity[]): Map<string, DocumentEntity[]> {
  const byIssueId = new Map<string, DocumentEntity[]>();
  for (const document of documents) {
    const ofIssue = byIssueId.get(document.issueId) ?? [];
    ofIssue.push(document);
    byIssueId.set(document.issueId, ofIssue);
  }
  return byIssueId;
}

/**
 * The PDF-eligible attachments of each issue, read from the stored documents in one
 * query; every issue gets counts, zero when it has none. Read for a report only, not
 * with every issue read.
 */
export async function readIssueAttachmentCounts(issueIds: string[]): Promise<AttachmentCountsOfIssues> {
  const byIssueId = groupByIssueId(await dbDocuments.getOwnDocumentsOfIssues(issueIds));
  return Object.fromEntries(
    issueIds.map((issueId) => [
      issueId,
      toAttachmentCounts((byIssueId.get(issueId) ?? []).map(toPdfClassifiableDocument).filter(isDefinedValue)),
    ])
  );
}
